<div class="page-wrapper">
  <header class="app-header">
    <img src="/assets/img/new-logo.png" alt="doqfy-logo" class="logo-image">
  </header>

  <div class="journey-container">
    <div class="content-side">
      <h2 class="main-heading">Welcome to Digital documentation journey!</h2>
      <p class="instruction-text">To complete your eSign process, you will need</p>

      <ul class="requirement-list">
        <li>Access to your registered Mobile number or Email ID for OTP verification</li>
        <li>Device has good network connectivity</li>
        <li>Mobile Pop up blocker is enabled</li>
      </ul>

      <div class="form-container">

        @if (!isOtpSent) {
          <p class="input-label mb-2">Enter your registered mobile number or email ID to receive an OTP</p>
        }

        <form [formGroup]="authForm">

          @if (!isOtpSent) {
            <div class="input-wrapper">
              <input
                type="text"
                formControlName="contactInfo"
                placeholder="Mobile number or Email ID"
                class="contact-input"
                [ngClass]="{'is-invalid': contactControl?.invalid && contactControl?.touched}"
              >

              @if (contactControl?.invalid && contactControl?.touched) {
                <div class="error-container">
                  @if (contactControl?.hasError('required')) {
                    <small class="error-text">This field is required.</small>
                  }
                  @if (contactControl?.hasError('invalidContactFormat')) {
                    <small class="error-text">Please enter a valid Email ID or 10-digit Mobile number.</small>
                  }
                </div>
              }
            </div>

            @if (apiErrorMessage) {
              <div class="api-error-message my-2">
                <small class="error-text">{{ apiErrorMessage }}</small>
              </div>
            }

            <button type="button" class="btn-proceed mt-2" [disabled]="contactControl?.invalid" (click)="sendOtp()">
              Send OTP
            </button>
          }

          @if (isOtpSent) {
            <div class="otp-instructions mb-3">
              <p style="color: #555; font-size: 0.95rem;">
                A 6-digit code has been sent to <strong>{{ contactControl?.value }}</strong>. Enter the code below.
              </p>
            </div>

            <div class="otp-wrapper" style="margin-bottom: 1.5rem;">
              <ng-otp-input
                (onInputChange)="onOtpChange($event)"
                [config]="otpConfig">
              </ng-otp-input>
            </div>

            <div class="resend-container mb-4">
              @if (timeLeft > 0) {
                <span class="timer-text">Resend OTP in <strong>00:{{ timeLeft < 10 ? '0'+timeLeft : timeLeft }}</strong></span>
              }
              @if (timeLeft === 0) {
                <span class="resend-link" (click)="sendOtp(true)">
                  Didn't receive it? <strong>Resend OTP</strong>
                </span>
              }
            </div>

            @if (apiErrorMessage) {
              <div class="api-error-message my-2">
                <small class="error-text">{{ apiErrorMessage }}</small>
              </div>
            }

            <button type="button" class="btn-proceed" [disabled]="otpControl?.invalid" (click)="verifyOtp()">
              Verify OTP
            </button>
          }

        </form>
      </div>
    </div>

    <div class="illustration-side">
      <img src="/assets/img/contract.svg" alt="Security Illustration" class="hero-image">
    </div>

  </div>
</div>
